module.exports = __webpack_public_path__ + "img/9788982736759.f6d38400.jpg";